export const ArabicToPersian = (text) => {
  
 
  const persianText = text
    ?.replace(/ي/g, "ی")
    ?.replace(/ك/g, "ک")
    ?.replace(/اً/g, "ًا");
  return persianText;
};
